import axios from "axios";
import { toast } from "react-toastify";
import ErrorCode from "../components/ErrorCodeV3/ErrorCode";

const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

class GenerateAbhaServices {
  async generateAdharOtpAbha(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/generate_otp_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if (response.data.txnId && response.data.message) {
        toast.success(response.data.message);
        return response;
      } else if (response.data.loginId && response.data.timestamp) {
        const errorMessage =
          response.data.loginId || "An unknown error occurred";
        toast.error(errorMessage);
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }

  async enrolByAadhaar(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/verify_aadhar_otp_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if (response.data.ABHAProfile && response.data.message) {
        if (
          post_data.authData.otp.mobile === response.data.ABHAProfile.mobile
        ) {
          toast.success(response.data.message);
          return response;
        } else {
          // toast.success(response.data.message);
          return response;
        }
      } else if (response.data.mobile && response.data.timestamp) {
        const errorMessage =
          response.data.mobile || "An unknown error occurred";
        toast.error(errorMessage);
      } else if (response.data.otpValue && response.data.timestamp) {
        const errorMessage =
          response.data.otpValue || "An unknown error occurred";
        toast.error(errorMessage);
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }
    } catch (error) {
      
      const errorResponse = error.response?.data?.error;
      if (errorResponse) {
        const errorCode = errorResponse.code;
        const errorMessage =
          errorResponse.message ||
          ErrorCode[errorCode] ||
          "An unknown error occurred";
        toast.error(errorMessage);
        throw new Error(errorMessage);
      } else {
        // Handle case where error structure is different or error response is not available
        const genericErrorMessage = "An unexpected error occurred";
        toast.error(genericErrorMessage);
        throw new Error(genericErrorMessage);
      }
    }
  }

  async generateHealthId(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/create_health_id_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if (response.data.healthIdNumber && response.data.preferredAbhaAddress) {
        toast.success(
          `ABHA Number: ${response.data.healthIdNumber}, ABHA Address: ${response.data.preferredAbhaAddress}`
        );
        return response;
      } else if (response.data.loginId && response.data.timestamp) {
        const errorMessage =
          response.data.loginId || "An unknown error occurred";
        toast.error(errorMessage);
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }

  async getProfileV3(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_profile_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if(response.data && response.data.ABHANumber){
        return response;
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }else{
        toast.error("An unknown error occurred")
        console.log(response.data)
      }
     
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }

  async getAbhaCardV3(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_card_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if(response.data && response.data.value){
        return response;
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }else{
        toast.error("An unknown error occurred")
        console.log(response.data)
      }
    
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }

  async sendOtpMobileUpdate(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/request_mobile_update_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if(response.data.txnId){
        toast.success(response.data.message)
        return response;
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }else{
        toast.error("An unknown error occurred")
        console.log(response.data)
      }
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
  async verifyOtpMobileUpdate(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/verify_mobile_update_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if (response.data.authResult === "success") {
        toast.success(response.data.message);
        return response;
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      } else if(response.data.otpValue){
        toast.error( response.data.otpValue);
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
  async getAbhaSuggestionV3(post_data, headers) {
    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_suggestion_v3/`,
        JSON.stringify(post_data),
        { headers: headers }
      );
      if (response.data.abhaAddressList){
        return response;
      }else if (response.data.error) {
        toast.error( response.data.error.message);
      }else{
        toast.error("An unknown error occurred")
        console.log(response.data)
      }
    } catch (error) {
      const errorCode = error.response?.data?.code;
      const errorMessage = ErrorCode[errorCode] || "An unknown error occurred";
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
}

export default new GenerateAbhaServices();
